<div class="login-page" [attr.dir]="dir">
  <div class="login-bg" aria-hidden="true"></div>

  <div class="login-layout">
    <!-- Login card: left side -->
    <section class="login-side login-side--form">
      <a
        routerLink="/"
        class="back-link"
        [attr.aria-label]="dir === 'rtl' ? 'العودة للصفحة الرئيسية' : 'Back to home'">
        <i class="pi" [ngClass]="dir === 'rtl' ? 'pi-arrow-right' : 'pi-arrow-left'"></i>
        <span>{{ dir === 'rtl' ? 'العودة للرئيسية' : 'Back to home' }}</span>
      </a>

      <div class="login-card">
        <div class="card-accent" aria-hidden="true"></div>

        <header class="card-header">
          <h1 class="card-title">{{ dir === 'rtl' ? 'تسجيل الدخول' : 'Sign in' }}</h1>
          <p class="card-subtitle">
            {{ dir === 'rtl'
              ? 'أدخل بياناتك للمتابعة إلى نظام الاستراتيجية الذكية.'
              : 'Enter your credentials to continue to Smart Strategy.' }}
          </p>
        </header>

        <form
          (ngSubmit)="onSubmit(loginForm)"
          #loginForm="ngForm"
          class="login-form"
          autocomplete="on">

          <div class="form-group">
            <label class="field-label" for="login-username">
              {{ dir === 'rtl' ? 'اسم المستخدم' : 'Username' }}
            </label>
            <div class="input-group">
              <i class="pi pi-user field-icon" aria-hidden="true"></i>
              <input
                id="login-username"
                type="text"
                required
                [(ngModel)]="userName"
                name="username"
                autocomplete="username"
                class="form-input"
                [placeholder]="dir === 'rtl' ? 'أدخل اسم المستخدم' : 'Enter your username'" />
            </div>
          </div>

          <div class="form-group">
            <label class="field-label" for="login-password">
              {{ dir === 'rtl' ? 'كلمة المرور' : 'Password' }}
            </label>
            <div class="input-group">
              <i class="pi pi-lock field-icon" aria-hidden="true"></i>
              <input
                id="login-password"
                required
                [type]="passwordFieldType"
                name="password"
                [(ngModel)]="passWord"
                autocomplete="current-password"
                class="form-input"
                [placeholder]="dir === 'rtl' ? 'أدخل كلمة المرور' : 'Enter your password'" />
              <button
                type="button"
                class="toggle-password"
                (click)="togglePasswordVisibility($event)"
                [attr.aria-label]="dir === 'rtl'
                  ? (passwordFieldType === 'password' ? 'إظهار كلمة المرور' : 'إخفاء كلمة المرور')
                  : (passwordFieldType === 'password' ? 'Show password' : 'Hide password')">
                <i [class]="passwordIconClass" aria-hidden="true"></i>
              </button>
            </div>
          </div>

          <label class="remember-checkbox">
            <input type="checkbox" class="checkbox-input" name="remember" />
            <span class="checkbox-label">
              {{ dir === 'rtl' ? 'تذكرني على هذا الجهاز' : 'Remember me on this device' }}
            </span>
          </label>

          <button
            type="submit"
            [disabled]="!loginForm.valid"
            class="login-btn">
            <span>{{ dir === 'rtl' ? 'تسجيل الدخول' : 'Sign in' }}</span>
            <i class="pi" [ngClass]="dir === 'rtl' ? 'pi-arrow-left' : 'pi-arrow-right'" aria-hidden="true"></i>
          </button>
        </form>

        <footer class="card-footer">
          <p class="copyright-text">
            {{ dir === 'rtl'
              ? 'جميع الحقوق محفوظة © 2026 مطار الشارقة'
              : '© 2026 Sharjah Airport. All rights reserved.' }}
          </p>
        </footer>
      </div>
    </section>

    <!-- Brand: right side -->
    <aside class="login-side login-side--brand">
      <div class="brand-panel">
        <img
          src="assets/images/sharjah-airport-logo.svg"
          alt="Sharjah Airport"
          class="brand-logo">
        <p class="brand-name">{{ dir === 'rtl' ? 'مطار الشارقة' : 'Sharjah Airport' }}</p>
        <h2 class="brand-title">
          {{ dir === 'rtl' ? 'نظام الاستراتيجية الذكية' : 'Smart Strategy System' }}
        </h2>
        <p class="brand-text">
          {{ dir === 'rtl'
            ? 'منصة موحدة لمتابعة الأهداف والمبادرات ومؤشرات الأداء لدعم قرارات التميز المؤسسي.'
            : 'A unified platform to track goals, initiatives, and performance indicators for better institutional decisions.' }}
        </p>
      </div>
    </aside>
  </div>
</div>

@if (showSuccessModal) {
  <app-success-modal
    [message]="dir == 'rtl' ? 'تم تسجيل الدخول بنجاح' : 'Login Successfully'">
  </app-success-modal>
}
